let colors = {
    primary100: '#003688',
    primary80: '#4075C5',
    primary60: '#7498CF',

    accent100: '#CED85A',
    accent80: '#E4ED80',

    neutral100: '#000813',
    neutral80: '#0F1928',
    neutral60: '#324052',
    neutral40: '#627389',
    neutral20: '#93A0B0',
    neutral10: '#BCC8D8',
    neutral0: '#F9FBFF'
}

export default colors
